import {
  HTTP_INSERTPROJECT_FETCHING,
  HTTP_INSERTPROJECT_SUCCESS,
  HTTP_INSERTPROJECT_FAILED,
  HTTP_UPDATEPROJECT_FETCHING,
  HTTP_UPDATEPROJECT_SUCCESS,
  HTTP_UPDATEPROJECT_FAILED,
  server,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

//insert Budgets
export const setStateinsertProjectToFetching = () => ({
  type: HTTP_INSERTPROJECT_FETCHING,
});

export const setStateinsertProjectToSuccess = (payload) => ({
  type: HTTP_INSERTPROJECT_SUCCESS,
  payload,
});

export const setStateinsertProjectToFailed = (payload) => ({
  type: HTTP_INSERTPROJECT_FAILED,
});

//update Budgets
export const setStateupdateProjectToFetching = () => ({
  type: HTTP_UPDATEPROJECT_FETCHING,
});

export const setStateupdateProjectToSuccess = (payload) => ({
  type: HTTP_UPDATEPROJECT_SUCCESS,
  payload,
});

export const setStateupdateProjectToFailed = (payload) => ({
  type: HTTP_UPDATEPROJECT_FAILED,
});

export const insertProjectById = (item) => {
  return async (dispatch) => {
    dispatch(setStateinsertProjectToFetching());
    try {
      await httpClient.post(`${server.INSERTPROJECT_URL}`, item);
      dispatch(setStateinsertProjectToSuccess("success"));
    } catch (error) {
      dispatch(setStateinsertProjectToFailed());
    }
  };
};

export const updateProjectById = (budgetpid, item) => {
  return async (dispatch) => {
    dispatch(setStateupdateProjectToFetching());
    try {
      await httpClient.put(`${server.UPDATEPROJECT_URL}/${budgetpid}`, item);
      dispatch(setStateupdateProjectToSuccess("success"));
    } catch (error) {
      dispatch(setStateupdateProjectToFailed());
    }
  };
};
